module.exports = __webpack_public_path__ + "static/SEO-0cc066632cd28c235cb2d0aeaaebc920.png";